import { getLanguage } from '../utils/sessionLanguage'

export const constructAuthHeader = (token) => {
    return ['Authorization', `JWT ${encodeURIComponent(token)}`]
}

export const makeHeaders = (token) => {
    const base = {
        'Content-Type': 'application/json',
        'Content-Language': getLanguage(),
    }

    if (token) {
        const [authHeader, jwt] = constructAuthHeader(token)
        base[authHeader] = jwt
    }

    return base
}

// Sesja unieważniona (np. zmiana hasła na innym urządzeniu) — sygnał dla SessionGuard.
const readJson = (auth) => (res) => res.json().then(json => {
    if (res.status === 401 && (json?.code === 'session_expired' || json?.code === 'account_suspended') && typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('spl:session-expired', { detail: { token: auth, code: json.code } }))
    }
    return json
})

export const get = ({ abortController, path, auth = '' }) => {
    return fetch(path, {
        headers: makeHeaders(auth),
        signal: abortController ? abortController.signal : undefined,
    })
    .then(readJson(auth))
}

export const post = ({ abortController, path, data = '', auth = '' }) => {
    return fetch(path, {
        body: JSON.stringify(data),
        headers: makeHeaders(auth),
        method: 'POST',
        signal: abortController ? abortController.signal : undefined,
    })
    .then(readJson(auth))
}

/* SWR functions */

// fetch unprotected:
export const apiFetcher = async (path) => await get({ path })

// avoids cache:
export const apiFetcherPost = async (path) => await post({ path })

// fetch protected:
export const apiFetcherProtected = (auth) => async (path) => await get({ path, auth })

// avoids cache:
export const apiFetcherProtectedPost = (auth) => async (path) => await post({ path, auth })

export default apiFetcher